import script from "./message-input-editor.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-input-editor.vue?vue&type=script&setup=true&lang=ts"

import "./message-input-editor.vue?vue&type=style&index=0&id=f5ea3c32&scoped=true&lang=scss"
import "./message-input-editor.vue?vue&type=style&index=1&id=f5ea3c32&lang=scss"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.31_vue@3.5.31_typescript@5.6.3__webpack@5.105.4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5ea3c32"]])

export default __exports__